module.exports = "https://s3-ap-southeast-2.amazonaws.com/slik-fonts/ufc0001/img/opponent-nate-diaz-6.7ee29e4f.jpg";